import { Component } from '@angular/core'
import { NzTableQueryParams } from 'ng-zorro-antd/table'
import { SaleService } from '../sale.service'
import { AppState } from '../../../core/core.state'
import { Store } from '@ngrx/store'
import { memberSelectors } from '../../member/member.selectors'
import { ConfigurationService } from '../../../shared/services/configuration.service'
import { organizationSelectors } from '../../organization/organization.selectors'
import { Actions } from '@ngrx/effects'
import { UntilDestroy } from '@ngneat/until-destroy'
import { saleSelectors } from '../sale.selectors'
import { saleActions } from '../sale.actions'
import { NzTableParamsService } from '../../../shared/services/nz-table-params.service'
import { StatusCode } from '../sale'

@UntilDestroy()
@Component({
  selector: 'sale-index-table-ajax',
  templateUrl: './sale-table-ajax.component.html',
  styleUrls: ['./sale-table-ajax.component.scss']
})
export class SaleTableAjaxComponent {
  memberEntities$ = this.store.select(memberSelectors.selectEntities)
  organizationEntities$ = this.store.select(
    organizationSelectors.selectEntities
  )
  pageSize = 2
  pageIndex = 1

  public saleCurrentData$ = this.store.select(
    saleSelectors.selectCurrentIndexData
  )
  public saleCurrentTotal$ = this.store.select(
    saleSelectors.selectCurrentIndexTotal
  )
  public isLoading$ = this.store.select(saleSelectors.selectIsLoading)
  saleStatusCode = StatusCode

  constructor(
    private saleService: SaleService,
    private store: Store<AppState>,
    public configService: ConfigurationService,
    private nzTableParamsService: NzTableParamsService,
    public actions$: Actions
  ) {}

  onQueryParamsChange(params: NzTableQueryParams): void {
    const queryParams = this.nzTableParamsService.getQueryParams(params)
    this.store.dispatch(saleActions.fetchIndex({ params: queryParams }))
  }
}
